import React, { FC, useState, useEffect, useCallback } from 'react'
import { useRequest } from '@/hooks/useRequest'
import { useSelector, useDispatch } from 'react-redux'
import { Sort } from './Sort'
import { AlterNames } from './AlterNames'
import { Literature } from './Literature'
import { SelectForm } from '@/components/SelectForm'
import { ISubj, ISubjData } from '@/types/fepoPages'
import { setSubjs, setSubjId, changeSort } from '../../actions'

interface IProps {
  specName: string | undefined
  isGeneral: boolean
  subjName: string | undefined,
  alternativeNames: string[] | undefined
}

export const Subjects: FC<IProps> = ({ specName, isGeneral, subjName, alternativeNames }) => {
  const dispatch = useDispatch()
  const { project, subjId, specId, pimId, specialities } = useSelector((state: any) => state)

  const [data, isLoading] = useRequest<ISubjData>({
    url: '/fgos_pim_struct/getSubjs',
    body: { specId },
    then: !!specId,
    onSuccess: (resData) => dispatch(setSubjs(resData))
  }, [specId])

  useEffect(() => {
    data && !isLoading && dispatch(setSubjs(data))
  }, [data])

  const subjData = () => {
      return data?.subjects?.map((s: ISubj) => ({
        id: s.id,
        value: s.name
      }))
  }

  return (
    <>

      <SelectForm
        data={subjData()}
        isLoading={isLoading}
        disabled={!specId}
        header={
          <Sort
            project={project}
            specId={specId}
            specName={specName}
            specLoading={isLoading}
          />
        }
        search
        onChange={useCallback((id: number) => dispatch(setSubjId(id)), [])}
      />
      {!!alternativeNames?.length && <AlterNames alterNames={alternativeNames} />}

      {!!subjId &&
        <Literature
          project={project}
          subjId={subjId}
          mypageUrl={specialities.mypageURL}
          isGeneral={isGeneral}
          pimId={pimId}
          subjName={subjName}
        />
      }
    </>
  )
}
